export default "__VITE_ASSET__4827b478__"